import React from 'react';
import Divider from '@mui/material/Divider';

const OptionsDropdownDivider = () => {
  return <Divider />;
};

export default OptionsDropdownDivider;
